export const BITRIDX_DOCUMENTS_NAMES = {
  customs_clearance_document:
    'Документ подтверждающий прохождение таможенного оформления',
  dkp: 'Договор купли-продажи подписанный ЭЦП с двух сторон (партнер и клиент)',
  obligations_confirmation_document:
    'Документ подтверждающий исполнение расширенных обязательств производителями (импортерами)',
  util_payment: 'Сведения об оплате утилизационного сбора'
};
